var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hasFCPAccess)?[_c('h4',{staticClass:"font-weight-bold text-center"},[_vm._v("Permission denied.")]),_c('p',{staticClass:"mb-0 text-sm text-center"},[_vm._v("You do not have valid FCP access.")])]:_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }